module.exports = require('./lib/vue-scroll');



//////////////////
// WEBPACK FOOTER
// ./~/.2.0.2@vue-scroll/index.js
// module id = 11
// module chunks = 1